import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import CalculatorsHub from "@/pages/CalculatorsHub";
import CalculatorRoute from "@/pages/CalculatorRoute";
import Compare from "@/pages/Compare";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import Account from "@/pages/Account";
import Products from "@/pages/Products";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Public = ({ children }) => <Layout>{children}</Layout>;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedAdmin({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="flex min-h-[60vh] items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function ProtectedUser({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="flex min-h-[60vh] items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/account" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Public><Home /></Public>} />
            <Route path="/calculators" element={<Public><CalculatorsHub /></Public>} />
            <Route path="/ecommerce/:slug" element={<Public><CalculatorRoute /></Public>} />
            <Route path="/compare" element={<Public><Compare /></Public>} />
            <Route path="/guides" element={<Public><Guides /></Public>} />
            <Route path="/guides/:slug" element={<Public><GuideArticle /></Public>} />
            <Route path="/account" element={<Public><Account /></Public>} />
            <Route path="/products" element={<Public><ProtectedUser><Products /></ProtectedUser></Public>} />
            <Route path="/pricing" element={<Public><Pricing /></Public>} />
            <Route path="/about" element={<Public><About /></Public>} />
            <Route path="/contact" element={<Public><Contact /></Public>} />
            <Route path="/privacy" element={<Public><Privacy /></Public>} />
            <Route path="/terms" element={<Public><Terms /></Public>} />
            <Route path="/disclaimer" element={<Public><Disclaimer /></Public>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
            <Route path="*" element={<Public><NotFound /></Public>} />
          </Routes>
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
